import languages from "@assets/data/languages";
import timezones from "@assets/data/timezones";

export interface IPreferrredType {
    type: string,
    subType: string
}


export enum Gender {
    female = "female",
    male = "male",
    diverse = "diverse",
    na = "na",
}
export const GENDERS = Object.values(Gender) as readonly Gender[];
// Default gender
export const DEFAULT_GENDER = Gender.na;


export enum VoiceType {
    feminine = "feminine",
    masculine = "masculine",
    neutral = "neutral",
    na = "na"
}
export const VOICE_TYPES = Object.values(VoiceType) as readonly VoiceType[];
// Default voice type
export const DEFAULT_VOICE_TYPE = VoiceType.na;

/*
// FIXME this is it seems the standard way without using an enum any only union types
export const PROFILE_SOCIAL_PLATFORMS = [
  "website",
  "linkedin",
  "facebook",
  "instagram",
  "tiktok",
  "youtube",
  "twitch",
  "discord",
  "twitter/X"
] as const;
export type ProfileSocialPlatform = typeof PROFILE_SOCIAL_PLATFORMS[number];
export const zProfileSocialPlatform = z.enum(PROFILE_SOCIAL_PLATFORMS);
 */


export enum ProfileSocialPlatform {
    WEBSITE = "website",
    LINKEDIN = "linkedin",
    FACEBOOK = "facebook",
    INSTAGRAM = "instagram",
    TIKTOK = "tiktok",
    YOUTUBE = "youtube",
    TWITCH = "twitch",
    DISCORD = "discord",
    TWITTER = "twitter/X"
}

export const PROFILE_SOCIAL_PLATFORMS = Object.values(ProfileSocialPlatform);

// Derive valid codes dynamically
//const lang: string[] = languages.map(l => l.code) as string[];
//export const VALID_LANGUAGES = languages.map(l => l.code) as string[];

// Cast as const for strong typing
export const LANGUAGES = languages as readonly {
    readonly code: string;
    readonly name: string;
}[];

//export const VALID_LANGUAGES = LANGUAGES.map(lang => lang.code) as readonly string[];
export const VALID_LANGUAGES = LANGUAGES.map(l => l.code) as typeof LANGUAGES[number]["code"][];
export const DEFAULT_LANGUAGE = "en"; // Default language
export type ValidLanguage = typeof VALID_LANGUAGES[number];

export const TIMEZONES = timezones as readonly {
    readonly value: string;
    readonly abbr: string;
    readonly offset: number;
    readonly isdst: boolean;
    readonly text: string;
    readonly utc: string[];
}[]

//export const VALID_TIMEZONES = timezones.map(tz => tz.value) as string[];
export const VALID_TIMEZONES = TIMEZONES.map(tz => tz.value) as typeof TIMEZONES[number]["value"][];
export const DEFAULT_TIMEZONE = "W. Europe Standard Time"// Default timezone
export type ValidTimezone = typeof VALID_TIMEZONES[number];
